<template>
  <div>
    <el-dialog title="Pull Exchange Rate" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">
      <el-form :model="dataForm" :rules="dataRule" ref="formRef" autocomplete="off" label-width="130px" label-position="left">
        <el-row :gutter="60">
          <el-col :span="16">
            <el-form-item label="End of Period" prop="month">
              <el-date-picker
                v-model="dataForm.month"
                type="month"
                value-format="yyyyMM"
                clearable
                :picker-options="pickerOptions"
                placeholder="Select Month"
                class="wdb100"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dataForm: {
        month: "",
      },
      dataRule: {
        month: [{ required: true, message: "Please select", trigger: "submit" }],
      },
      pickerOptions: {
        disabledDate(time) {
          const now = new Date();
          const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
          return time.getTime() >= firstDayOfCurrentMonth.getTime();
        },
      },
      submitLoading: false,
    };
  },
  methods: {
    // 初始化
    async init() {
      this.submitLoading = false;
      this.dialogVisible = true;
      await this.$nextTick();
      this.$refs.formRef.resetFields();
      this.dataForm = {
        month: "",
      };
    },
    // 表单提交
    async formSubmitRequest() {
      const month = this.dataForm.month;
      // 检查该月份汇率是否已存在
      const checkRes = await this.$http.get("/admin/exchangeRateByMonth/isMonthExists", {
        params: { month },
      });
      if (checkRes.data) {
        // 选中月的汇率已存在，确认是否覆盖
        await this.$confirm("The exchange rate for the selected month already exists. Do you want to overwrite it?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        });
      }
      // 拉取汇率
      return await this.$http.post("/admin/exchangeRateByMonth/pullByMonth", {}, { params: { month } });
    },
    dataFormSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false;
                  this.$emit("update");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
